<template>
  <layout name="Notification">
    <VSystemMessage primaryText="Reset Password">
      <div class="reset-password">
        <VForm
          :name="name"
          :fields="fields"
          :submitButton="{
            label: 'Change password',
            classType: 'primary giant'
          }"
          :disabled="isLoading"
          @submit="onSubmit"
        >
        </VForm>
      </div>
    </VSystemMessage>
  </layout>
</template>

<script>
import Vue from "vue";
import { mapActions } from "vuex";
import Layout from "@/layouts/Layout";

// components
import VForm from "@/components/VForm";
import VSystemMessage from "@/components/VSystemMessage";

// mixins
import withToasted from "@/mixins/withToasted";
import withNavigate from "@/mixins/withNavigate";
import withValidation from "@/mixins/withValidation";
import withFormUtils from "@/mixins/withFormUtils";

import { required, minLength } from "@/utils/validations";

export default Vue.component("ResetPassword", {
  metaInfo: {
    title: "Reset Password"
  },

  components: {
    VForm,
    Layout,
    VSystemMessage
  },

  mixins: [withToasted, withNavigate, withValidation, withFormUtils],

  data() {
    return {
      name: "resetPassword",
      fields: [
        {
          name: "password",
          placeholder: "********",
          label: "Password",
          classType: "primary",
          type: "password",
          validate: [required, minLength(8), this.checkPasswords]
        },
        {
          name: "password_repeat",
          placeholder: "********",
          label: "Confirm Password",
          classType: "primary",
          type: "password",
          validate: [required, minLength(8), this.checkPasswords]
        }
      ],

      token: null,
      email: null
    };
  },

  methods: {
    onSubmit() {
      if (this.isValid) {
        this.resetPasswordFinish({
          token: this.token,
          data: { password: this.formValues.password, email: this.email },
          onSuccess: () => {
            this.navigate("/reset-password/success");
          },

          onError: e => {
            this.toast(e, "error");
          }
        });
      }
    },

    ...mapActions("auth", ["resetPasswordFinish"])
  },

  computed: {
    isLoading() {
      return this.$store.state.auth.isLoading;
    }
  },

  created() {
    const { token, email } = this.$route.query;

    if (!token || !email) {
      this.toast(
        "Token or email is missing. You will be redirected in 3 seconds.",
        "error",
        { duration: 3000 }
      );

      setTimeout(() => {
        this.replace("/forgot-password");
      }, 2000);
    } else {
      this.token = token;
      this.email = email;
    }
  }
});
</script>

<style lang="scss" scoped>
.reset-password {
  margin: auto;
  max-width: 70%;
}
</style>
